"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var share = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 931 1000", fill: "currentColor", width: size || '1em', height: size || '1em' }, props),
        React.createElement("path", { d: "M746 653c-58 0-109 29-139 74L333 583c3-12 4-25 4-38 0-26-6-50-16-72l302-184c31 34 75 56 125 56 92 0 167-75 167-167S840 11 748 11 581 86 581 178c0 27 7 52 18 75L297 437c-31-36-76-58-127-58C78 379 4 453 4 545c0 93 74 167 166 167 64 0 120-36 148-88l270 142c-5 17-9 35-9 54 0 92 75 166 167 166s167-74 167-166c0-93-75-167-167-167", fill: "currentColor" })));
};
share.displayName = 'share';
exports.default = share;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=share.js.map